import ActiveRecord from './active_record/base'
import {getGlobal} from '../helpers'
import {upperFirst} from 'lodash'

class Team extends ActiveRecord {
	static tableName = 'teams'
	static defaultJoins = ['environments']
	static sort = [{field: 'locked', direction: 'desc'}, 'naam']

	fullName() {
		if (!getGlobal('isMultiEnv')) return this.naam
		return `${this.environment?.naam} - ${this.naam} `
	}

	// Safely create a new method, instead of using above fullName method.
	// Beware: the environments must be joined in for this to work. If you
	// want to use this multiEnv logic but joining is not an option, you can
	// pass in the environment name as an argument.
	nameWithEnv(envName = this.environment?.naam) {
		const teamName = upperFirst(this.naam)
		const meMultiEnv = getGlobal('meMultiEnv')

		const inDevelopment = process.env.NODE_ENV === 'development'
		const developmentWarning = `${teamName} (Environment not joined!)`

		if (meMultiEnv && !envName && inDevelopment) return developmentWarning
		if (!meMultiEnv || !envName) return teamName

		if (this.modelConfig?.formatNameWithEnv) return this.modelConfig.formatNameWithEnv(teamName, envName)

		return `${teamName}, ${upperFirst(envName)}`
	}
}

export default Team
